<template>
  <header class="header">
    <div class="header__top" v-if="$store.state.contacts">
      <div class="header__top__container">
        <a class="header__phone" :href="`tel:${$store.state.contacts.phone_hot}`" v-if="$store.state.contacts.phone_hot || $store.state.contacts.phone" :aria-label="$store.state.contacts.phone_hot" title="Телефон горячей линии">
          <span class="header__phone__title">Телефон горячей линии:</span>
          <span class="header__phone__text">{{ ($store.state.contacts.phone_hot || $store.state.contacts.phone) }}</span>
        </a>
        <a href="javascript:void(0);" class="header__impaired bvi-open" title="Версия сайта для слабовидящих" aria-label="Версия сайта для слабовидящих">
          <i class="header__impaired__icon" aria-hidden="true">
            <eye-icon/>
          </i>
          <span class="header__impaired__text">Версия сайта для слабовидящих</span>
        </a>
        <a href="javascript:void(0);" @click="mm = !mm" class="header__mm__toggle" title="Меню" aria-label="Меню">
          <i class="header__mm__toggle__icon" v-if="!mm" aria-hidden="true">
            <m-m/>
          </i>
          <i class="header__mm__toggle__icon" v-else aria-hidden="true">
            <m-m-close/>
          </i>
        </a>
      </div>
    </div>
    <div class="header__mm" v-if="mm">
      <ul class="header__mm__list">
        <template v-for="(link, index) in $store.state.nav">
          <li class="header__mm__list__item" :key="index" v-if="!link.hidden" @click="mm = false">
            <router-link :to="{ name: link.route }" class="header__mm__link" :title="link.name" :aria-label="link.name">{{ link.name }}</router-link>
          </li>
        </template>
      </ul>
      <a class="header__mm__phone" :href="`tel:${$store.state.contacts.phone_hot}`" :aria-label="$store.state.contacts.phone_hot" title="Телефон горячей линии">
        <span class="header__mm__phone__title">Телефон горячей линии:</span>
        <span class="header__mm__phone__text">{{ ($store.state.contacts.phone_hot || $store.state.contacts.phone) }}</span>
      </a>
    </div>
    <div class="header__menu" v-if="$store.state.nav && $store.state.nav.length">
      <nav class="header__menu__container">
        <ul class="header__menu__list">
          <template v-for="(link, index) in $store.state.nav">
            <li class="header__menu__list__item" :key="index" v-if="!link.hidden">
              <router-link :to="{ name: link.route }" class="header__menu__link" :title="link.name" :aria-label="link.name">
                <span class="header__menu__link__text">{{ link.name }}</span>
                <i class="header__menu__link__icon" aria-hidden="true" v-if="link.child_navigator && link.child_navigator.length">
                  <submenu-icon/>
                </i>
              </router-link>
              <ul class="header__menu__submenu" v-if="link.child_navigator && link.child_navigator.length">
                <li class="header__menu__submenu__item" v-for="(sublink, i) in link.child_navigator.filter(l => !l.parent_id)" :key="i">
                  <router-link
                    v-if="!sublink.url"
                    :to="{ name: 'partition', params: { id: sublink.id } }"
                    class="header__menu__submenu__link"
                    :title="sublink.title"
                  >
                    {{ sublink.title }}
                  </router-link>
                  <a
                    v-else
                    :href="sublink.url"
                    class="header__menu__submenu__link"
                    :title="sublink.title"
                  >
                    {{ sublink.title }}
                  </a>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import EyeIcon from './svg/EyeIcon.vue'
import SubmenuIcon from './svg/SubmenuIcon.vue'
import MM from './svg/MM.vue'
import MMClose from './svg/MMClose.vue'

export default {
  name: 'HeaderComponent',
  components: {
    MMClose,
    MM,
    SubmenuIcon,
    EyeIcon
  },
  data() {
    return {
      mm: false
    }
  }
}
</script>
